import React, { Component } from 'react';
import UniverseError from './UniverseError';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console for debugging
    console.error('React Error Boundary caught an error:', error);
    console.error('Error info:', errorInfo);

    // You could also log to an error reporting service here
    // e.g., Sentry, LogRocket, etc.
  }

  handleRetry = () => {
    // Reset error state and try again
    this.setState({ hasError: false, error: null });

    // Optionally reload the page for a fresh start
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return <UniverseError onRetry={this.handleRetry} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
